module.exports = __webpack_public_path__ + "static/gdpr-01d5d8f80c633b61d74d3ce1b5de2abc.png";